export const loginImage =
	"https://smcore.blob.core.windows.net/logos/coou-login.png";
export const landingPageImage =
	"https://smcore.blob.core.windows.net/logos/coou-landing.png";
export const birthdayImage =
	"https://smcore.blob.core.windows.net/logos/birthday.png";
